const languages = [
  { label: "English", code: "en" },
  { label: "Spanish", code: "es" },
];

export default languages;
